import styled, {ThemeProps} from 'styled-components';
import {Assign} from 'utility-types';

// TYPES
import {Row} from '../../../../../stories/components/hotels/common/Layouts/Layouts';

// THEME
import {Theme} from '../../../../../stories/theme/types';

const RoomTextInfoWrapperStyled = styled(Row)((
  props: Assign<ThemeProps<Theme>, {spacedOutBy?: string}>,
) => {
  const padding = `${props.spacedOutBy ? props.spacedOutBy : 0} 0`;
  const width = `${props.width ? props.width : ''}`;
  const display = `${props.display ? props.display : ''}`;
  return `
    padding: ${padding};
    align-items: center;
    width:${width};
    display:${display};
  `;
});

const RoomInfoTextStyled = styled.span(
  (props: Assign<ThemeProps<Theme>, {color?: string}>) => `
  // padding: 0 ${props.theme.spacing.base};
  font-size: ${props.fontSize ? props.fontSize : props.theme.font.custom(14)};
  color: ${props.color ? props.color : 'inherit'};
  display: flex;
  align-items: ${props.alignItems ? props.alignItems : 'baseline'};
  font-weight: 600;
`,
);

const RoomInfoText: React.FC<{
  children: React.ReactNode;
  textColor?: string;
  spacedOutBy?: string;
  alignItems?: string;
  width?: string;
  display?: string;
}> = ({children, textColor, spacedOutBy, alignItems, width, display}) => {
  return (
    <RoomTextInfoWrapperStyled spacedOutBy={spacedOutBy} width={width} display={display}>
      <RoomInfoTextStyled color={textColor} alignItems={alignItems}>
        {children}
      </RoomInfoTextStyled>
    </RoomTextInfoWrapperStyled>
  );
};
export default RoomInfoText;
